import React from 'react';
import AdminManager from '../components/admin';

class AdminPage extends React.Component{

	render(){
		return (
			<div>
				<AdminManager />
			</div>
		)
	}

}

export default AdminPage;


// WEBPACK FOOTER //
// ./src/containers/admin-page.js